import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { NgbDate, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { strict } from 'assert';
import { APIResponse } from '../../Entity';

@Injectable({
  providedIn: 'root'
})
export class CommonService {

  public baseUrl: string;
  public guidelineSetupUrl: string;

  constructor(private http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    this.baseUrl = baseUrl + 'api/v1/';
    this.guidelineSetupUrl = this.baseUrl + 'GuidelineSetup';
  }

  toFormData(obj) {
    let formData = new FormData();
    for (const property in obj) {
      const value = obj[property];
      if (value != null && value !== undefined) {
        formData.append(property, value);
      }
    }

    return formData;
  }

  setUserInfoToLocalStorage(value) {
    localStorage.setItem('userinfo', JSON.stringify(value));
  }

  getUserInfoFromLocalStorage(): any {
    if (!localStorage.getItem('userinfo')) return null;
    return JSON.parse(localStorage.getItem('userinfo'));
  }

  setActivityPermissionToSessionStorage(value) {
    localStorage.setItem('activitypermission', JSON.stringify(value));
  }

  getActivityPermissionToSessionStorage(): any {
    if (!localStorage.getItem('activitypermission')) return null;
    return JSON.parse(localStorage.getItem('activitypermission'));
  }

  DownloadFile(file: Blob | ArrayBuffer, fileName: string, type: string): void {
    var blob = new Blob([file], { "type": type })

    var link = document.createElement("a");
    let reader = new FileReader();
    reader.readAsDataURL(blob);
    link.download = fileName;
    reader.onload = function () {
      if (typeof (reader.result) === 'string') {
        link.href = reader.result; // data url
        link.click();
      }

    };
    link.click();
  }
  ngbDateToDate(date: NgbDateStruct): Date | null {
    if (!!date) {
      return new Date(date.year, date.month - 1, date.day);
    }
    return null;
  }

  getLastDateOfMonth(date): Date | null {
    if (!!date) {
      var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
      return lastDay;
    }

    return null;
  }

  days_between(date) {

    if (!!date) {
      var lastDay: any = new Date(date.getFullYear(), date.getMonth() + 1, 0);
      const ONE_DAY = 1000 * 60 * 60 * 24;
      const differenceMs = Math.abs(date - lastDay);

      return Math.round(differenceMs / ONE_DAY);
    }

    return null;

  }

  dateToNgbDate(date: Date): NgbDateStruct | null {
    if (date != null) {
      let newDate = new Date(date);
      let ngbDateStruct = { day: newDate.getDate(), month: newDate.getMonth() + 1, year: newDate.getFullYear() } as NgbDateStruct;
      return ngbDateStruct;
    }
    return null;
  }

  stringToDate(date: string): NgbDateStruct | null {
    if (date != null) {
      let spliteTime = date.split('T')[0];
      if (spliteTime) {
        let newDate = new Date(spliteTime);
        let ngbDateStruct = { day: newDate.getDate(), month: newDate.getMonth() + 1, year: newDate.getFullYear() } as NgbDateStruct;
        return ngbDateStruct;
      }
    }
    return null;
  }



  public downloadTargetSetupExcelFile(demo) {
    return this.http.post(this.baseUrl + "Node/DownloadTemplateFile", demo, { observe: 'response', responseType: 'blob' });
  }
  public downloadRouteExcelFile(demo) {
    return this.http.post(this.baseUrl + "Campaign/DownloadSalesPointWiseRouteTemplate", demo, { observe: 'response', responseType: 'blob' });
  }
  public downloadChannelExcelFile(demo) {
    return this.http.post(this.baseUrl + "Campaign/DownloadChannelWiseTemplate", demo, { observe: 'response', responseType: 'blob' });
  }
  viewMediaFile(fileName) {
    return this.http.get(`${this.baseUrl}Media?filePath=${fileName}`);
  }
  downloadMediaFile(fileName) {
    return this.http.get(`${this.baseUrl}Media/Download?filePath=${fileName}`, { responseType: 'blob' });
  }
  public uploadFile(File: File) {
    let formParams = new FormData();
    formParams.append('file', File)
    return this.http.post<APIResponse>(`${this.guidelineSetupUrl}/Upload`, formParams);
  }


}
